import { MatLegacySnackBarRef as MatSnackBarRef } from "@angular/material/legacy-snack-bar";
import { Observable } from "rxjs";

import { SnackBarOptions, SnackBarComponentBase, TranslationGroup } from "./abstract-snackbar.model";

export abstract class AbstractTranslatableSnackBarService {
	abstract openSnackBar$(
		config: SnackBarOptions,
		translationGroups?: TranslationGroup[],
		interpolateParams?: object | undefined
	): Observable<MatSnackBarRef<SnackBarComponentBase>>;

	abstract dismissSnackBar(): void;
}
